import { ModalService, SimpleMessageService, Tenant, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserDto } from 'src/app/models/user/create-user-dto';
import { UserManagementService } from 'src/app/services/user-management.service';
import { UserRowComponent } from '../user-row/user-row.component';

@Component({
    selector: 'oaibox-delete-user-warning-modal',
    templateUrl: './delete-user-warning-modal.component.html',
    styleUrl: './delete-user-warning-modal.component.css',
    imports: [WebAppCommonModule, forwardRef(() => UserRowComponent)],
})
export class DeleteUserWarningModalComponent implements OnDestroy {
  @Input({required: true}) user!: UserDto;
  @Input() tenant?: Tenant;

  private userSubscription?: Subscription;

  constructor(
    private readonly simpleMessageService: SimpleMessageService,
    private readonly modalService: ModalService,
    private readonly userManagementService: UserManagementService,
  ) {
  }

  protected deleteUser(): void {
    if (this.user.id) this.userSubscription = this.userManagementService.deleteUser(this.user.id)
      .subscribe({
        next: () => {
          this.userManagementService.refreshUsers();
          this.simpleMessageService.showSimpleMessage({
            message: 'User deleted successfully!', icon: 'fa-solid fa-check-double', color: 'success'
          });
          this.modalService.popModal();
        },
        error: () => {
          this.simpleMessageService.showSimpleMessage({
            message: 'User not deleted!', icon: 'fa-solid fa-triangle-exclamation', color: 'danger'
          });
          this.modalService.popModal();
        },
      });
  }

  protected cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
  }
}
